import {DeserializedElement, DeserializedLeaf, DeserializedNode, DeserializedRules} from "../Transformation";
import React, {ReactElement} from "react";
import {Element} from "slate";
import {renderToStaticMarkup} from "react-dom/server";
import strip_tags from "locutus/php/strings/strip_tags";
/*
const parseMustacheTextNode = (node) => {
    if (node.text !== undefined && node.text.indexOf("{{") !== -1 && node.text.indexOf("}}") !== -1) {
        const splitText = node.text.split(/([\{][\{][^\}]+[\}][\}])/g);
        return splitText.map((s) => {
            if (/{{[^}]+}}/g.test(s)) {
                const variable = s.substring(2, s.length-2);
                return {type: "variable", props: {type: "mustache", variable}};
            } else {
                return {text: s};
            }
        });
    }
    return node;
}

const mustacheNodeParser = (node) => {
    if (node.children !== undefined) {
        const nodes = [];
        node.children.map((n) => {
            const r = mustacheNodeParser(n);
            if (Array.isArray(r)) {
                nodes.push.apply(nodes, r);
            } else {
                nodes.push(r);
            }
        });
        node.children = nodes;
    } else {
        const r = parseMustacheTextNode(node);
        if (Array.isArray(r)) {
            return r;
        }
    }
    return node;
}

const trim = (node) => {
    if (node.children !== undefined) {
        const nodes = [];
        node.children.map((n) => {
            const r = trim(n);
            if (Array.isArray(r)) {
                nodes.push.apply(nodes, r);
            } else {
                nodes.push(r);
            }
        });
        node.children = nodes;
    } else {
        if (node.text !== undefined) {
            node.text = node.text.trim();
        }
    }
    return node;
}

const mustacheTags = (deserialized) => {
    return deserialized.map((n) => mustacheNodeParser(n));
}
*/
const importFromMustache = (data: string|DataTransfer, rules: DeserializedRules<string>) => {
    if (data instanceof DataTransfer) {
        data = data.getData('text/plain');
    }
    data = strip_tags(data).replace(/\&/g, "&amp;");
    const build = (el: string, rules: DeserializedRules<string>): DeserializedElement => {
        let allRules = [...Object.values(rules.elements), ...Object.values(rules.leaves)];
        for (let i = 0; i < allRules.length; i++) {
            let obj = allRules[i].deserialize(el, children => Array.from(children || []).reduce((all, child) => {
                let next = build(child, rules);
                if (Array.isArray(next)) {
                    all = [...all, ...next];
                } else {
                    all = [...all];
                    all.push(next);
                }
                return all;
            }, []))
            if (obj !== undefined) {
                if (Array.isArray(obj)) {
                    obj = obj.map((o) => {
                        // normalize json dom for slate
                        if (o?.type && !o.children?.length) {
                            o.children = [{text: ''}];
                        }
                        return o;
                    })
                } else {
                    // normalize json dom for slate
                    if (obj?.type && !obj.children?.length) {
                        obj.children = [{text: ''}];
                    }
                }
                return obj;
            }
        }
        return null;
    }
    let array = [
        {
            type: 'block',
            children: data.split(/({{[a-zA-Z_]+[a-zA-Z0-9_\.]*}})/).reduce((all, el) => {
                let next = build(el, rules);
                if (Array.isArray(next)) {
                    all = [...all, ...next];
                } else {
                    all = [...all];
                    all.push(next);
                }
                return all;
            }, [])
        }
    ];
    //console.log(JSON.parse(JSON.stringify(array)));
    return array;
}

const arrayToString = (array) => {
    return Array.isArray(array) ? array.map((array) => arrayToString(array)).join('') : array;
}

const exportToMustache = (node, rules: DeserializedRules<string>) => {
    const build = (node: DeserializedNode, rules: DeserializedRules<string>): null|undefined|string => {
        if (
            !Element.isElement(node)
        ) {
            node = node as DeserializedLeaf;
            let leaf: null|undefined|string = node.text;
            let leafKeys = Object.keys(rules.leaves);
            for (let i = 0; i < leafKeys.length; i++) {
                let next = rules.leaves[leafKeys[i]].serialize(node, leaf, children => children?.map((child) => build(child, rules)))
                if (next !== undefined) {
                    leaf = next;
                }
            }
            return leaf;
        } else {
            node = node as DeserializedElement;
            let elementKeys = Object.keys(rules.elements);
            for (let i = 0; i < elementKeys.length; i++) {
                let serialized = rules.elements[elementKeys[i]].serialize(node, children => children?.map((child) => build(child, rules)))
                if (serialized !== undefined) {
                    return serialized;
                }
            }
        }
        return null;
    }
    const body = arrayToString(node.map((node, key) => {
        return build(node, rules);
    }));
    //console.log(strip_tags(body).replace(/\&amp;/g, "&"));
    return strip_tags(body).replace(/\&amp;/g, "&");
}

export {importFromMustache, exportToMustache};